import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { $authHost } from './index'

export const addAddress = async (addressData) => {
	const { data } = await $authHost.post('api/user/addaddress', addressData)
	return data
}

export const updateAddress = async (updateData) => {
	const { data } = await $authHost.post('api/user/updateaddress', updateData)
	return data
}

export const deleteAddress = async (deleteData) => {
	const { data } = await $authHost.post('api/user/deleteaddress', deleteData)
	return data
}

export const findAllAddress = async () => {
	const { data } = await $authHost.post('api/user/findalladdress')
	return data
}

export const useAddresses = () => {
	return useQuery(['addresses'], findAllAddress)
}

export const useAddAddress = () => {
	const queryClient = useQueryClient()

	return useMutation(addAddress, {
		onSuccess: () => {
			queryClient.invalidateQueries(['addresses'])
		},
	})
}

export const useUpdateAddress = () => {
	const queryClient = useQueryClient()

	return useMutation(updateAddress, {
		onSuccess: () => {
			queryClient.invalidateQueries(['addresses'])
		},
	})
}

export const useDeleteAddress = () => {
	const queryClient = useQueryClient()

	return useMutation(deleteAddress, {
		onSuccess: () => {
			queryClient.invalidateQueries(['addresses'])
		},
	})
}
